import { render, staticRenderFns } from "./MayaSuccessPageView.vue?vue&type=template&id=38d43502&"
import script from "./MayaSuccessPageView.vue?vue&type=script&lang=js&"
export * from "./MayaSuccessPageView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports